import apiClient from './client';
import { PageResultDto } from 'interfaces/page';
import { ErganiAttendanceCreateRequestDto, ErganiAttendanceDto, ErganiAttendanceQueryDto } from 'interfaces/ergani';
import { ErganiApiError, erganiRequest, toErganiApiError } from './erganiCommon';

/**
 * Attendance check-in / check-out (work card), POST/GET `/ergani/attendance`.
 *
 * Unlike the other ERGANI areas, rejections are translated in the UI (`ErganiAttendanceErrorCode`
 * in `attendanceUtils`) or mapped by HTTP status (404 => unknown employee). Every failure is
 * therefore surfaced as an `ErganiApiError` carrying the backend code / HTTP status — or the
 * ERGANI message when ERGANI itself rejected the event (502, `fromErgani`).
 */

interface ErganiAttendanceService {
  createAttendance(request: ErganiAttendanceCreateRequestDto): Promise<ErganiAttendanceDto>;
  searchAttendance(queryParams: ErganiAttendanceQueryDto): Promise<PageResultDto<ErganiAttendanceDto>>;
}

const endpoints = {
  attendance: '/ergani/attendance',
};

/** Converts request failures into `ErganiApiError`; errors that already are one pass through. */
const withErganiApiError = async <T>(request: () => Promise<T>): Promise<T> => {
  try {
    return await request();
  } catch (error) {
    throw error instanceof ErganiApiError ? error : toErganiApiError(error);
  }
};

export const erganiAttendanceServices: ErganiAttendanceService = {
  createAttendance: (request: ErganiAttendanceCreateRequestDto): Promise<ErganiAttendanceDto> =>
    withErganiApiError(() => erganiRequest(() => apiClient.post(endpoints.attendance, request))),

  searchAttendance: (queryParams: ErganiAttendanceQueryDto): Promise<PageResultDto<ErganiAttendanceDto>> =>
    withErganiApiError(() => erganiRequest(() => apiClient.get(endpoints.attendance, { params: { ...queryParams } }))),
};
